export default __webpack_public_path__ + "static/media/290.803b0520.gif";